import React from "react";

import { PreguntaDeIntento, ResultadoPregunta } from "../../../../services/v2/lmsQuiz.service";
import { Icono } from "../comun";
import { puntosTxt } from "../tareas/comunTareas";
import { TIPO_PREGUNTA } from "./editorQuiz";
import "./quiz.css";

/*
	Una pregunta ya contestada (Resultados del maestro y "Ver Mis Respuestas" del alumno). Lo correcto en naranja, lo que eligió mal
	en oro. Las correctas, la explicación y los puntos solo aparecen si el servidor los mandó (al alumno, según el ajuste del quiz).
*/

const RESULTADO: Record<ResultadoPregunta, { texto: string; clase: string }> = {
	correcta: { texto: "Correcta", clase: "pcChipAcento" }, parcial: { texto: "Parcial", clase: "" }, incorrecta: { texto: "Incorrecta", clase: "pcChipOro" },
	sin_respuesta: { texto: "Sin Respuesta", clase: "pcChipBorde" }, por_calificar: { texto: "Por Calificar", clase: "pcChipAcento" },
}

export const ChipResultado: React.FC<{ q: PreguntaDeIntento }> = ({ q }) => {
	const pts = q.earned !== undefined && q.earned !== null ? puntosTxt(q.earned) + " / " + puntosTxt(q.points) : puntosTxt(q.points) + (Number(q.points) === 1 ? " Pt" : " Pts")
	if (!q.result) return <span className="pcChip pcChipBorde">{pts}</span>
	const r = RESULTADO[q.result]
	return <span className={"pcChip " + r.clase}>{r.texto}{q.result !== "por_calificar" && q.earned !== undefined && q.earned !== null ? " · " + pts : ""}</span>
}

interface Props
{
	q: PreguntaDeIntento
	n: number
	/** Calificar Párrafo (solo el maestro): el valor escrito y cómo cambiarlo. */
	calificar?: { valor: string; onCambio: (v: string) => void; deshabilitado?: boolean }
}

export const RespuestaVista: React.FC<Props> = ({ q, n, calificar }) => {
	const elegidas: string[] = Array.isArray(q.answer) ? q.answer : typeof q.answer === "string" ? [q.answer] : []
	const conCorrectas = q.options.some((o) => o.correct !== undefined)
	const imagen = q.image?.url || q.imageUrl || null
	return (
		<div className="qzRespuesta">
			<div className="qzRespuestaCabeza">
				<span className="qzMiniNumero" aria-hidden="true">{n}</span>
				<span>{q.text}</span>
				<ChipResultado q={q} />
			</div>
			<div className="pcTenue pcChico" style={{ marginTop: -4 }}>{TIPO_PREGUNTA[q.type]}</div>
			{imagen ? <div className="qzFoto" style={{ maxWidth: 360 }}><img src={imagen} alt={"Imagen de la pregunta " + n} /></div> : null}
			{q.type === "opcion" || q.type === "casillas" || q.type === "vf" ? (
				<div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
					{q.options.map((o) => {
						const elegida = elegidas.includes(o.id || "")
						const clase = conCorrectas ? (o.correct ? " qzCorrecta" : elegida ? " qzMal" : "") : ""
						return (
							<div key={o.id} className={"qzOpcionVista" + (elegida ? " qzElegida" : "") + clase}>
								<span className="qzIcoOpcion" aria-hidden="true">{conCorrectas && o.correct ? <Icono n="check" size={16} /> : conCorrectas && elegida ? <Icono n="cerrar" size={14} /> : elegida ? "•" : ""}</span>
								<span>{o.text}{elegida ? <span style={{ position: "absolute", left: -9999 }}> (elegida)</span> : null}{conCorrectas && o.correct ? <span style={{ position: "absolute", left: -9999 }}> (correcta)</span> : null}</span>
							</div>
						)
					})}
					{elegidas.length === 0 ? <div className="pcTenue pcChico">No contestó.</div> : null}
				</div>
			) : (
				<>
					{typeof q.answer === "string" && q.answer.trim() !== "" ? <div className="qzTextoLibre">{q.answer}</div> : <div className="pcTenue pcChico">No contestó.</div>}
					{q.type === "corta" && q.accepted && q.accepted.length > 0 ? <div className="pcTenue pcChico">Respuestas aceptadas: {q.accepted.join(" · ")}</div> : null}
				</>
			)}
			{calificar && q.type === "parrafo" ? (
				<div className="qzCalificaParrafo">
					<label htmlFor={"qp" + q.id} className="pcCampoEtiqueta">Puntos</label>
					<input id={"qp" + q.id} inputMode="decimal" value={calificar.valor} disabled={calificar.deshabilitado} onChange={(e) => calificar.onCambio(e.target.value)} aria-label={"Puntos de la pregunta " + n + " (de " + puntosTxt(q.points) + ")"} />
					<span className="pcTenue" style={{ fontWeight: 700 }}>/ {puntosTxt(q.points)}</span>
				</div>
			) : null}
			{q.explanation ? <div className="qzExplica"><b>Explicación:</b> {q.explanation}</div> : null}
		</div>
	)
}
